import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { WalletService } from '../services/wallet.service';

export const walletConnectGuard: CanActivateFn = () => {
  const walletService = inject(WalletService);
  const router = inject(Router);

  if (walletService.isConnected()) {
    return true;
  }

  return router.createUrlTree(['/onboarding']);
};
